import { render, staticRenderFns } from "./JdsTextArea.vue?vue&type=template&id=75f14421"
import script from "./JdsTextArea.vue?vue&type=script&lang=js"
export * from "./JdsTextArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports